<template>
  <v-card style="height: 100%">
    <project-flow-navigation-toolbar
      :title="poiName"
    ></project-flow-navigation-toolbar>
    <v-toolbar dark dense>
      <v-tabs v-model="tab">
        <v-tab> Details </v-tab>
        <v-tab> Media </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items
      style="height: calc(100% - 112px); position: relative"
      v-model="tab"
    >
      <v-tab-item style="height: 100%">
        <v-card class="full-height-card">
          <v-card-text>
            <v-row class="mt-1">
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  dense
                  v-model="poi.name"
                  label="Name"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="poi.poiTypeId" label="Poi Type"></v-text-field>
              </v-col>-->
              <v-col
                v-if="
                  $store.state.UserStore.userRole[0] === 'super_admin' ||
                    'project_admin'
                "
                cols="12"
                sm="6"
                md="4"
              >
                <v-select
                  readonly
                  dense
                  :items="$store.state.PoiStore.poiTypes"
                  v-model="poi.poiTypeId"
                  label="Poi Type"
                  item-text="name"
                  item-value="typeId"
                ></v-select>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  readonly
                  dense
                  v-model="$store.state.PoiStore.selectedType.type.parentType"
                  label="Parent Type"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  readonly
                  dense
                  :items="$store.state.PoiStore.selectedType.availableParents"
                  v-model="poi.parentId"
                  label="Select parent"
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-col>
            </v-row> -->
          </v-card-text>
          <v-spacer />
          <v-card-actions>
            <v-btn color="red darken-1" @click="deletePoi">Delete</v-btn>
            <v-spacer></v-spacer>
            <v-fade-transition>
              <span v-if="changeDetected" class="caption amber--text d-flex align-center mr-2">
                <v-icon x-small color="amber" class="mr-1">mdi-circle-medium</v-icon>Unsaved changes
              </span>
            </v-fade-transition>
            <v-btn v-if="changeDetected" text @click="discard">Discard</v-btn>
            <v-btn
              color="blue darken-1"
              :disabled="saveButtonDisabled"
              @click="save"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <media ref="media" :media="this.$store.state.MediaStore.media"></media>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import ProjectFlowNavigationToolbar from '../../components/AppBar/ProjectFlowNavigationToolbar'
import Enums from '../../helpers/Enums'
import Media from '../../views/Media'
import { MediaGalleryLeaveGuardMixin } from '../../mixins/MediaGalleryLeaveGuardMixin'

export default {
  name: 'PoiExplore',
  mixins: [MediaGalleryLeaveGuardMixin],
  props: {},
  components: {
    ProjectFlowNavigationToolbar,
    Media
  },
  data: function() {
    return {
      title: '',
      tab: null,
      poi: {},
      changeDetected: false
    }
  },
  computed: {
    poiName: function() {
      return this.$store.state.PoiStore.selectedPoi
        ? this.$store.state.PoiStore.selectedPoi.name
        : ''
    },
    saveButtonDisabled: function() {
      return !this.changeDetected
    }
  },
  methods: {
    getData: async function(poiId) {
      if (this.$route.params.poiId) {
        await this.$store.dispatch('MediaStore/resetStore')

        await this.$store.dispatch(
          'PoiStore/setSelectedPoi',
          this.$route.params.poiId,
          { root: true }
        )
        this.poi = JSON.parse(
          JSON.stringify(this.$store.state.PoiStore.selectedPoi)
        )
        await this.$store.dispatch('MediaStore/setMediaContext', 'poi')
        await this.$store.dispatch('MediaStore/fetchMediaTypes')
        await this.$store.dispatch('MediaStore/fetchMedia')
      } else {
        return
      }
    },
    save: async function() {
      await this.$store.dispatch('PoiStore/updatePoi', this.poi)
      // Updateovanje poia se sada izvrsava u updatePoi akciji:
      // await this.$store.dispatch(
      //   'PoiStore/setSelectedPoi',
      //   this.$route.params.poiId
      // )
      this.poi = JSON.parse(
        JSON.stringify(this.$store.state.PoiStore.selectedPoi)
      )
      this.changeDetected = false
    },
    discard() {
      this.poi = JSON.parse(JSON.stringify(this.$store.state.PoiStore.selectedPoi))
      this.changeDetected = false
    },
    deletePoi: async function() {
      this.$confirm({
        title: 'Delete POI',
        text: 'Are you sure?',
        acceptText: 'DELETE',
        cancelText: 'CANCEL'
      })
        .then(y => {
          this.$store
            .dispatch('PoiStore/deletePoi', this.$route.params.poiId)
            .then(
              () => {
                this.$router.go(-1)
                this.$emit('deleted')
              },
              err => {
                this.$store.dispatch(
                  'NotificationStore/add',
                  {
                    type: 'error',
                    message:
                      'Poi has media records attached, it cannot be deleted.'
                  },
                  { root: true }
                )
              }
            )
        })
        .catch(n => {
          console.log('NO')
        })
    }
  },

  created: async function() {},
  mounted: function() {},
  watch: {
    poi: {
      // This will let Vue know to look inside the object
      deep: true,
      handler: function(after, before) {
        if (JSON.stringify(before) !== '{}') {
          this.changeDetected =
            JSON.stringify(this.poi) !==
            JSON.stringify(this.$store.state.PoiStore.selectedPoi)
        }
      }
    },
    tab(newVal, oldVal) {
      this.guardMediaTabSwitch(newVal, oldVal, 1)
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getData(parseInt(to.params.poiId))
    })
  },
  async beforeRouteUpdate(to, from, next) {
    await this.confirmLeaveMediaGalleryIfDirty()
    this.getData(to.params.poiId)
    next()
  },
  async beforeRouteLeave(to, from, next) {
    await this.confirmLeaveMediaGalleryIfDirty()
    next()
  }
}
</script>

<style scoped></style>
